<template>
  <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <div class="text-center flex justify-between">
        <h6 class="text-blueGray-700 text-xl font-bold">API Management {{ pageType }}</h6>
        <button
          class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          type="button" @click="onSubmit(client)">
          Submit
        </button>
      </div>
    </div>
    <div class="flex-auto px-4 lg:px-10 py-10 pt-0">

      <div class="w-full lg:w-12/12 px-4 mt-3" v-if="alertType != ''">
        <div class="text-white px-4 py-2 border-0 rounded relative mb-4"
          v-bind:class="{ 'bg-emerald-500': alertType == 'Success', 'bg-red-500': alertType == 'Failed' }">
          <span class="text-m inline-block mr-5 align-middle">
            <i class="fas fa-bell"></i>
          </span>
          <span class="inline-block align-middle mr-8">
            <b class="capitalize">{{ alertType }}!</b> {{ alertMessage }}
          </span>
          <button
            class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-2 mr-6 outline-none focus:outline-none">
            <span>×</span>
          </button>
        </div>
      </div>
      <div class="flex flex-wrap mt-3">
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
              Client Name
            </label>
            <select v-model="client.client_name"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
              <option v-for="(item, key) in clients" :value="item.client_name" :key="key">
                {{ item.client_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
              App Name
            </label>
            <input type="text" v-model="client.app_name" name="app_name"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
              Version
            </label>
            <input type="text" v-model="client.version" name="version"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Intention
            </label>
            <input type="text" v-model="client.intention" name="intention"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Description
            </label>
            <textarea type="text" v-model="client.description" name="description"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Parameters
            </label>
            <textarea type="text" v-model="client.query_param" name="query_param"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
              Method
            </label>
            <select v-model="client.method"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
              <option v-for="(item, key) in methods" :value="item" :key="key">
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Destination
            </label>
            <input type="text" v-model="client.destination" name="destination"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
          </div>
        </div>

        <div class="w-full lg:w-6/12 px-4 flex mt-5">
          <div class="w-full lg:w-6/12 mb-3">
            <label class="inline-flex items-center cursor-pointer">
              <input type="checkbox" v-model="client.is_cache_return" name="is_cache_return"
                class="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150">
              <span class="ml-2 text-sm font-semibold text-blueGray-600"> Cache Return </span>
            </label>
          </div>
          <div class="w-full lg:w-6/12 mb-3">
            <label class="inline-flex items-center cursor-pointer">
              <input type="checkbox" v-model="client.is_mock_api" name="is_mock_api"
                class="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150">
              <span class="ml-2 text-sm font-semibold text-blueGray-600"> Mock API </span>
            </label>
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Static Bearer
            </label>
            <textarea type="text" v-model="client.static_bearer_token_forward" name="static_bearer_token_forward"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
          </div>
        </div>

        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Mock Return
            </label>
            <textarea type="text" v-model="client.mock_return" name="mock_return"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import ClientDataService from "@/services/ClientDataService";
import constants from "@/constants";
import ErrorHandler from "@/ErrorHandler";
export default {
  data() {
    return {
      client: this.clientProps,
      clients: [],
      methods: []
    };
  },
  props: {
    pageType: String,
    onSubmit: { type: Function },
    alertType: String,
    alertMessage: String,
    showModal: Boolean,
    toggleModal: { type: Function },
    clientProps: { type: Object }
  },
  watch: {
    clientProps: function (newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.client = newVal
    }
  },
  mounted() {
    this.methods = constants.methods
    this.getClients()
  },
  methods: {
    getClients() {
      ClientDataService.getAll(100, 1)
        .then(response => {
          this.clients = response.data["data"]["clients"];
        })
        .catch(e => {
          console.log(e);
          ErrorHandler(e)
        });
    },
  }
}
</script>